module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11PJIOQ/tc-custom/9781783830763.jpg?1713496982567",
      "alt": "This image is the cover for the book Tracing Your Pauper Ancestors, Tracing Your Ancestors"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tracing Your Pauper Ancestors, Tracing Your Ancestors\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A practical and informative guide for family historians interested in researching their British ancestry through social welfare records.")]), _c('br'), _c('br'), _vm._v("Many family historians will come across direct links to ancestors who were affected by poverty. Yet despite the burgeoning interest in genealogy, the history of pauperism and of poor relief has rarely been written about. "), _c('i', [_vm._v("Tracing Your Pauper")]), _c('i', [_vm._v("Ancestors ")]), _vm._v("provides a guide to documents and records that family researchers can use to trace their pauper ancestors. "), _c('br'), _c('br'), _vm._v("Author Robert Burlison gives a vivid account of poverty and the poor in the United Kingdom, discussing its causes, the many forms of charitable relief, and the largely repressive Poor Laws. He identifies relevant records, indicates where they can be found, and offers essential advice on how this information can be used to piece together the lives of distant and not so distant relatives.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Burlison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Robert Burlison is an author and historian.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0